import whyNomNomSlide1Src from '@images/marketing/WhyNN-Hero1.jpg';
import whyNomNomSlide2Src from '@images/marketing/WhyNN-Hero2.jpg';
import whyNomNomSlide3Src from '@images/marketing/WhyNN-Hero3.jpg';
export var whyNomNomImageGliderContent = {
    buttonLabel: 'Get Started',
    headline: 'The Food Your Dog Deserves',
    subhead: 'There’s no mistaking a dog that’s actually excited about dinner. It’s why our meals are carefully crafted for complete nutrition and floor-licking delicious taste.',
    images: [
        {
            src: whyNomNomSlide1Src,
            alt: 'A dog licks its lips while its owner places a bowl of Nom Nom food on the floor.',
            width: 390,
            height: 479,
        },
        {
            src: whyNomNomSlide2Src,
            alt: 'Product image of a bowl of Nom Nom dog food',
            width: 162,
            height: 170,
            offsetY: 46,
        },
        {
            src: whyNomNomSlide3Src,
            alt: 'Close up of a dog eating Nom Nom dog food from a bowl',
            width: 272,
            height: 286,
            offsetY: 143,
        },
    ],
};
export var weDeliverSectionContent = {
    headline: 'We Deliver Dog Food to Dog Foodies',
    subhead: 'No more bulky bags, confusing serving sizes and meals that don’t have your dog’s nutrition and tastes in mind.  Nom Nom brings exactly what they need directly to your door.',
    images: [
        {
            src: whyNomNomSlide1Src,
            alt: 'A dog licks its lips while its owner places a bowl of Nom Nom dog food on the floor.',
            width: 390,
            height: 479,
        },
        {
            src: whyNomNomSlide2Src,
            alt: 'Product image of a bowl of Nom Nom dog food',
            width: 162,
            height: 170,
            offsetY: 46,
        },
        {
            src: whyNomNomSlide3Src,
            alt: 'Close up of a dog eating Nom Nom dog food from a bowl',
            width: 272,
            height: 286,
            offsetY: 143,
        },
    ],
};
